import api from './tbrosApi';

const butterflyApi = {

  /**
   * 응답 구조
   * {
   *  "content": "동화 내용"
   * }
   */
  async getStories(scriptNo, heroNo) {
    const response = await api.get(`/manage/heroes/${heroNo}/scriptNo/${scriptNo}/stories`)
    if (!response || response.status > 299) return
    return response.data
  },

  async updateStories(scriptNo, heroNo, content) {
    const response = await api.put(`/manage/heroes/${heroNo}/scriptNo/${scriptNo}/stories`,
      {
        "content": content
      })
    if (!response || response.status > 299) return
    return response.data
  },


  async getScriptPrompt(scriptNo, useGpt, heroNo = 1) {
    const response = await api.postLong(`/heroes/${heroNo}/scripts/${scriptNo}/v2?useGpt=${useGpt}`)
    if (!response || response.status > 299) return
    return response.data
  },

  async getManageScripts() {
    const response = await api.get(`/manage/scripts`)
    if (!response || response.status > 299) return
    return response.data
  },

  /***
   * 
   * return   
    scriptNo: Int,
    title: String,
    summary: String,
    instagram: String?,
    script: String,
    mainImageUrl: String?,
   */
  async getScript(scriptNo) {
    const response = await api.get(`/manage/scripts/${scriptNo}`)
    if (!response || response.status > 299) return
    return response.data
  },


  async createScript(title, summary, instagram, script, mainImageUrl, use, hot, imageTags) {
    const response = await api.post(`/manage/scripts`, {
      title, summary, instagram, script, mainImageUrl, use, hot, imageTags,
    })
    if (!response || response.status > 299) return
    return response.data
  },

  async updateScript(
    scriptNo,
    title,
    summary,
    instagram,
    script,
    mainImageUrl,
    use,
    hot,
    imageTags,
  ) {
    const response = await api.put(`/manage/scripts/${scriptNo}`, {
      title: title,
      summary: summary,
      instagram: instagram,
      script: script,
      mainImageUrl: mainImageUrl,
      use: use,
      hot: hot,
      imageTags: imageTags,
    })
    if (!response || response.status > 299) return
    return response.data
  },

  async updateNotifiedDate(heroNo, scriptNos) {
    const response = await api.post(`/manage/notified?heroNo=${heroNo}&scriptNos=${scriptNos}`)
    if (!response || response.status > 299) return
    return response.data

  },

  async leave() {
    const response = await api.delete(`/supporters`)
    if (!response || response.status > 299) return
    return response.data
  },

  async updateEmailAgree(emailAgree) {
    const response = await api.put(`/supporters/emailAgree`, {
      emailAgree: emailAgree
    })
    if (!response || response.status > 299) return
    return response.data
  },

  /**
[
  {
    "heroNo": 28,
    "scriptNo": 11,
    "notifyDatetime": "2026-02-08 12:29:45",
    "maskedHeroName": "김*빈",
    "imageUrl": "https://image.toast.com/aaaaaud/public/images/gpt/b92161aa-db70-40af-9304-ccf8e81bdab6.jpg"
  },
]
   */
  async getProcessing() {
    const response = await api.get(`/manage/processing`)
    if (!response || response.status > 299) return
    return response.data
  },

  async getHistory(heroNo, supporterNo, byUser = true) {
    const response = await api.get(`/manage/history?${heroNo && ('heroNo=' + heroNo + '&') || ''}${supporterNo && ('supporterNo=' + supporterNo + '&') || ''}byUser=${byUser}`)
    if (!response || response.status > 299) return
    return response.data
  },

  async pauseHero(heroNo) {
    const response = await api.post(`/manage/heroes/${heroNo}/pause`)
    if (!response || response.status > 299) return
    return response.data
  },

  async releaseHero(heroNo) {
    const response = await api.post(`/manage/heroes/${heroNo}/release`)
    if (!response || response.status > 299) return
    return response.data
  },

  async updateWritingReady(heroNo, ready) {
    const response = await api.put(`/heroes/${heroNo}/writingReady?ready=${ready}`)
    if (!response || response.status > 299) return
    return response.data
  },

  async getScriptInfo(heroNo, scriptNo) {
    const response = await api.get(`/scripts/${scriptNo}?${heroNo && ('heroNo=' + heroNo) || ''}`)
    if (!response || response.status > 299) return
    return response.data
  },

  async getRecomendedFeatures(scriptNo, heroNo) {
    const response = await api.get(`/heroes/${heroNo}/scripts/${scriptNo}/features`)
    if (!response || response.status > 299) return
    return response.data
  },

  async makeMyStory(scriptNo, heroNo) {
    const response = await api.postLong(`/heroes/${heroNo}/scripts/${scriptNo}`)
    if (!response || response.status > 299) return
    return response.data
  },

  async getSupporter() {
    const response = await api.get(`/supporter`)
    if (!response || response.status > 299) return
    return response.data
  },

  async addHero(firstName, lastName, imageUrl, gender, birthYear) {
    const response = await api.post(`/heroes`, {
      firstName: firstName,
      lastName: lastName,
      imageUrl: imageUrl,
      gender: gender,
      birthYear: birthYear,
    })
    if (!response || response.status > 299) return
    return response.data
  },

  async updateHeroImage(
    heroNo, imageUrl
  ) {
    const response = await api.putLong(`/heroes/${heroNo}`, {
      imageUrl: imageUrl
    })
    if (!response || response.status > 299) return
    return response.data
  },

  async updateHero(heroNo, firstName, lastName, gender, birthYear) {
    const response = await api.putLong(`/heroes/${heroNo}`, {
      firstName: firstName,
      lastName: lastName,
      gender: gender,
      birthYear: birthYear,
    })
    if (!response || response.status > 299) return
    return response.data
  },

  async deleteHero(heroNo) {
    const response = await api.delete(`/heroes/${heroNo}`)
    if (!response || response.status > 299) return
    return response.data
  },

  async deleteHeroFeatures(heroNo, heroFeatureContentNos) {
    const response = await api.delete(`/heroes/${heroNo}/features?heroFeatureContentNos=${heroFeatureContentNos}`)
    if (!response || response.status > 299) return
    return response.data
  },

  /***
   *  val heroFeatureContentNo: Int?,
   *  val answer: String,
   */
  async updateHeroFeatures(heroNo, models) {
    const response = await api.putLong(`/heroes/${heroNo}/features`, models)
    if (!response || response.status > 299) return
    return response.data
  },

  /***
   *  val heroFeatureNo: Int,
   *  val answer: String,
   */
  async addHeroFeatures(heroNo, models) {
    const response = await api.post(`/heroes/${heroNo}/features`, models)
    if (!response || response.status > 299) return
    return response.data
  },

  async getHeroFeatures(heroNo) {
    const response = await api.get(`/heroes/${heroNo}/features`)
    if (!response || response.status > 299) return
    return response.data
  },
  async getHeroes(onError) {
    const response = await api.get(`/heroes`, onError)
    if (!response || response.status > 299) return
    return response.data
  },

  async getScripts(heroNo) {
    const response = await api.get(`/scripts?${heroNo && ('heroNo=' + heroNo) || ''}`)
    if (!response || response.status > 299) return
    return response.data
  },

  async getApps(category, heroNo, onError) {
    if (typeof heroNo === 'function') {
      onError = heroNo
      heroNo = undefined
    }

    const query = new URLSearchParams()
    if (category) query.set('category', category)
    if (heroNo) query.set('heroNo', heroNo)

    const response = await api.get(`/apps${query.toString() ? `?${query.toString()}` : ''}`, onError)
    if (!response || response.status > 299) return
    return response.data
  },

  async readyAppPayment(appNo, heroNo, onError) {
    const response = await api.post(`/apps/${appNo}/payments/ready`, {
      heroNo: heroNo
    }, onError)
    if (!response || response.status > 299) return
    return response.data
  },

  async approveAppPayment(orderId, amount, tid, authToken, onError) {
    const response = await api.post(`/apps/payments/approve`, {
      orderId: orderId,
      amount: amount,
      tid: tid,
      authToken: authToken,
    }, onError)
    if (!response || response.status > 299) return
    return response.data
  },

  async getAppPaymentOrder(orderId, heroNo, onError) {
    const response = await api.get(`/apps/payments/orders/${orderId}${heroNo ? `?heroNo=${encodeURIComponent(heroNo)}` : ''}`, onError)
    if (!response || response.status > 299) return
    return response.data
  },

  async getAppProductions() {
    const response = await api.get(`/supporters/app-productions`)
    if (!response || response.status > 299) return
    return response.data
  },

  async getAppProduction(productionNo) {
    const response = await api.get(`/supporters/app-productions/${productionNo}`)
    if (!response || response.status > 299) return
    return response.data
  },

  async createSupportInquiry(category, title, content, heroNo, onError) {
    const response = await api.post(`/supporters/inquiries`, {
      category: category,
      title: title,
      content: content,
      heroNo: heroNo || null,
    }, onError)
    if (!response || response.status > 299) return
    return response.data
  },

  async getSupportInquiries(status, category, onError) {
    const query = new URLSearchParams()
    if (status) query.set('status', status)
    if (category) query.set('category', category)

    const response = await api.get(`/supporters/inquiries${query.toString() ? `?${query.toString()}` : ''}`, onError)
    if (!response || response.status > 299) return
    return response.data
  },

  async getSupportInquiry(inquiryNo, onError) {
    const response = await api.get(`/supporters/inquiries/${inquiryNo}`, onError)
    if (!response || response.status > 299) return
    return response.data
  },

  async getManageInquiries(status, category, supporterNo, onError) {
    const query = new URLSearchParams()
    if (status) query.set('status', status)
    if (category) query.set('category', category)
    if (supporterNo) query.set('supporterNo', supporterNo)

    const response = await api.get(`/manage/inquiries${query.toString() ? `?${query.toString()}` : ''}`, onError)
    if (!response || response.status > 299) return
    return response.data
  },

  async getManageInquiry(inquiryNo, onError) {
    const response = await api.get(`/manage/inquiries/${inquiryNo}`, onError)
    if (!response || response.status > 299) return
    return response.data
  },

  async getManageAppPaymentOrders(onError) {
    const response = await api.get(`/manage/app-payments/orders`, onError)
    if (!response || response.status > 299) return
    return response.data
  },

  async updateManageInquiry(inquiryNo, status, answerContent, onError) {
    const data = { status: status }
    if (answerContent !== undefined) {
      data.answerContent = answerContent
    }

    const response = await api.put(`/manage/inquiries/${inquiryNo}`, data, onError)
    if (!response || response.status > 299) return
    return response.data
  },

  async getHeroStory(heroNo, scriptNo) {
    const response = await api.get(`/heroes/${heroNo}/scripts/${scriptNo}`)
    if (!response || response.status > 299) return
    return response.data
  },

  async getHeroStoryAudios(heroNo, scriptNo) {
    const response = await api.get(`/heroes/${heroNo}/scripts/${scriptNo}/audios`)
    if (!response || response.status > 299) return
    return response.data
  },

  async getSummary() {
    const response = await api.get(`/manage/summary`)
    if (!response || response.status > 299) return
    return response.data
  },

  async getTasks(heroNo) {
    const response = await api.get(`/manage/tasks?${heroNo && ('heroNo=' + heroNo) || ''}`)
    if (!response || response.status > 299) return
    return response.data
  },

  async getBotTasks(scriptNo, heroNo) {
    const response = await api.get(`/manage/scripts/${scriptNo}/heroes/${heroNo}/bot-tasks`)
    if (!response || response.status > 299) return
    return response.data
  },

  async getImagePrompt(heroNo, scriptNo) {
    const response = await api.post(`/heroes/${heroNo}/scripts/${scriptNo}/imagePrompt/v2`)
    if (!response || response.status > 299) return
    return response.data
  },

  async updateStory(heroStoryNo, content) {
    const response = await api.post(`/manage/stories/${heroStoryNo}`, {
      content: content
    })
    if (!response || response.status > 299) return
    return response.data
  },

  async requestImageChange(heroNo, scriptNo, pageNo, content) {
    const response = await api.put(`/heroes/${heroNo}/scripts/${scriptNo}/pages/${pageNo}/imageRequest`, {
      content: content
    })
    if (!response || response.status > 299) return
    return response.data
  },

  async updateStoryContent(heroNo, scriptNo, pageNo, content) {
    const response = await api.put(`/heroes/${heroNo}/scripts/${scriptNo}/pages/${pageNo}/content`, {
      content: content
    })
    if (!response || response.status > 299) return
    return response.data
  },

  async updateStoryImage(heroNo, scriptNo, pageNo, imageUrl) {
    const response = await api.putLong(`/manage/${heroNo}/scripts/${scriptNo}/pages/${pageNo}/image`, {
      imageUrl: imageUrl
    })
    if (!response || response.status > 299) return
    return response.data
  },

  async getImageUpdateTasks() {
    const response = await api.get(`/manage/tasks/image-update`)
    if (!response || response.status > 299) return
    return response.data
  },

  async getHoldingTasks() {
    const response = await api.get(`/manage/tasks/holding`)
    if (!response || response.status > 299) return
    return response.data
  },

  async boostTasks(scriptNo, heroNo) {
    const response = await api.post(`/manage/scripts/${scriptNo}/heroes/${heroNo}/boost`)
    if (!response || response.status > 299) return
    return response.data
  },

  /***
   *   {                                                                                                                                                                                                     
          "holding": false,                                                                                                                                                                                   
          "pendingCount": 3                                       
        }   
   */
  async getImageTaskQueue(heroNo, scriptNo) {
    const response = await api.get(`/heroes/${heroNo}/scripts/${scriptNo}/imageTask/queue`)
    if (!response || response.status > 299) return
    return response.data
  },

  async deleteTask(scriptNo, heroNo, taskType) {
    const response = await api.delete(`/manage/scripts/${scriptNo}/heroes/${heroNo}/tasks?taskType=${taskType}`)
    if (!response || response.status > 299) return
    return response.data
  },

  async createTask(heroNo, scriptNo, taskType) {
    const response = await api.post(`/mcp/tasks?heroNo=${heroNo}&scriptNo=${scriptNo}&taskType=${taskType}`)
    if (!response || response.status > 299) return
    return response.data
  }
}

export default butterflyApi
